module.exports = __webpack_public_path__ + "media/images/groupRank__eval--wrong@3x-25445a79bbd7b3484b266a0390ac9ea8.png";